/**
 * The blacksmiths (ช่างตีเหล็ก) who forge weapons (ตีบวก, ตีธาตุ; data/forge.ts). Forging is done at a smith, not in
 * the bag: talking to one opens the forge window, and `forge`/`infuse` are refused away from every smith
 * (systems/items.ts). A zone's smiths stand at a spot by the plaza (`at` a landmark, `plaza` the map's plaza, moved
 * by `dx`, `dy` metres to the nearest free ground); any townsperson titled ช่างตีเหล็ก (data/npcActs.ts) forges too.
 */
import type { ZoneId } from './zones';

export interface SmithDef {
  readonly zone: ZoneId;
  readonly name: string;
  readonly sprite: string;
  readonly at: string;
  readonly dx: number;
  readonly dy: number;
  readonly facing?: 1 | -1;
}

/** The title every smith wears, and the one that makes a townsperson a smith. */
export const SMITH_TITLE = 'ช่างตีเหล็ก';

/** How near a smith (metres) the player must stand to forge. */
export const SMITH_REACH = 4;

export const SMITHS: readonly SmithDef[] = [
  // The demo plaza's smithy corner (data/offlineWork.ts's smith spot, 46, 18), and the same plaza in the new Yanyu.
  { zone: 'demoPlaza', name: 'ช่างเหล็กเฉิน', sprite: 'farmer', at: 'plaza', dx: 7, dy: -20, facing: -1 },
  { zone: 'yanyu2', name: 'ช่างเหล็กเฉิน', sprite: 'farmer', at: 'plaza', dx: 7, dy: -20, facing: -1 },
];
